module.exports = [{
      plugin: require('/Users/chenyangtie/Documents/nodejs/gats1/awsmath24/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
